var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("my-multiselect", {
    ref: "my_multiselect",
    attrs: {
      options: _vm.items,
      placeholder: _vm.label,
      name: _vm.name,
      clearable: _vm.clearable,
      "allow-empty": _vm.allowEmpty,
      label: "name",
      "track-by": "id"
    },
    on: { input: _vm.valueUpdated },
    model: {
      value: _vm.current_value,
      callback: function($$v) {
        _vm.current_value = $$v
      },
      expression: "current_value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }